import {Object3D} from 'three'
import {BaseNumericLoader} from './BaseNumericLoader'

export default class LoaderObject extends BaseNumericLoader {
  constructor() {
    super()
  }

  async waitForLoad(): Promise<void> {
    return Promise.resolve()
  }

  clearAllObjects(): void {
    this.clearAll()
  }

  /**
   * Получение объектов по числовому ключу (для обратной совместимости)
   * Возвращает readonly Record для защиты от изменений извне
   */
  get objects(): Readonly<Record<number, Object3D>> {
    return this.getNumericObjects()
  }

  addObject(center: [number, number]): Object3D | null {
    return null
  }
}
